import store from './store'
import update from './update'
import relateModules from './relateModules'
import relateMembers from './relateMembers'

const namespaced = true

export default {
  namespaced,
  modules: {
    store,
    update,
    relateModules,
    relateMembers
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/forms/index.js